import { render, staticRenderFns } from "./AttachmentsPage.vue?vue&type=template&id=25aa2700&scoped=true&"
import script from "./AttachmentsPage.vue?vue&type=script&lang=js&"
export * from "./AttachmentsPage.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsPage.vue?vue&type=style&index=0&id=25aa2700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aa2700",
  null
  
)

export default component.exports